import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Card as CardMaterial,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  FormControlLabel,
  Checkbox,
  CardMedia,
  Tooltip,
  createTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteCertificado,
  getCertificadoById,
  postCertificado,
  updateCertificado,
} from "../../../../api/certificado";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import MultiTabBlock from "../../../components/MultiTabBlock";
import Table, { buttonsStyle } from "../../../components/tables/table";
import { SERVER_URL } from "../../../../api";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import { Delete, Visibility } from "@material-ui/icons";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyCertificado() {
  return {
    link: "",
    imageUrl: "",
    active: true,
  };
}

export default function EditCertificadoPage() {
  const [certificado, setCertificado] = useState(getEmptyCertificado());
  const imageInputRef = useRef(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(null);
  const certificadoId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    const fetch = async () => {
      if (!certificadoId) {
        disableLoadingData();
        return;
      }
      getCertificadoById(certificadoId)
        .then((res) => {
          if (res.status === 200) {
            const certificado = res.data;
            setCertificado(certificado);

            disableLoadingData();
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not get certificado.",
          });
          history.push("/certificados");
        });
    };
    fetch();
  }, [certificadoId, disableLoadingData, history]);

  function saveCertificado() {
    let saveCertificado = certificado;
    if (!certificadoId) {
      postCertificado(saveCertificado, selectedImage)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Certificado successfully created.",
            });
            history.push("/certificados");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save certificado.",
          });
        });
    } else {
      updateCertificado(certificadoId, saveCertificado, selectedImage)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Changes successfully saved.",
            });
            history.push("/certificados");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save changes.",
          });
        });
    }
  }

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === " ") return;

      if (!certificado[element]) certificado[element] = {};
      let newText = certificado[element];
      newText[lang] = event.target.value;
      setCertificado({ ...certificado, [element]: newText });
    } else setCertificado({ ...certificado, [element]: event.target.value });
  };

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>

                  {showDelete && (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        onClick={onDelete}
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        className="text-nowrap"
                      >
                        Delete
                      </Button>
                    </MuiThemeProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderContentDatosGenerales = () => {
    return (
      <>
        <div className="d-flex align-text-center">
          <div className="col-md-12">
            <TextField
              id={`link`}
              label="Link de destino"
              value={certificado.link ? certificado.link : ""}
              onChange={handleChange("link")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
          </div>
        </div>
        <div className="d-flex align-text-center">
          <div className="col-md-2">
            <FormControlLabel
              control={
                <Checkbox
                  checked={certificado.isOwn}
                  onChange={() =>
                    setCertificado({
                      ...certificado,
                      isOwn: !certificado.isOwn,
                    })
                  }
                  name="checkOwn"
                />
              }
              label="Subir una imagen"
            />
          </div>
          <div className="col-md-10">
            {!certificado.isOwn ? (
              <TextField
                id={`imageUrl`}
                label="Link de la imagen"
                value={certificado.imageUrl ? certificado.imageUrl : ""}
                onChange={handleChange("imageUrl")}
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined"
                required
              />
            ) : (
              <>
                <CardMaterial>
                  {(selectedImage || certificado.imageUrl) && (
                    <CardMedia
                      component="img"
                      alt="New"
                      style={{
                        objectFit: "contain",
                        width: "100%",
                        height: "auto",
                        maxHeight: "600px",
                      }}
                      image={
                        selectedImage
                          ? URL.createObjectURL(selectedImage)
                          : `${SERVER_URL}/${certificado.imageUrl}`
                      }
                    />
                  )}
                </CardMaterial>
                <label htmlFor={"upload-media"} className="ml-0 my-4">
                  <input
                    ref={imageInputRef}
                    style={{ display: "none" }}
                    id={"upload-media"}
                    name={"upload-media"}
                    type="file"
                    accept={"image/*"}
                    onChange={(e) => {
                      setSelectedImage(e.target.files[0]);
                    }}
                  />
                  <Button
                    style={{ marginRight: "15px" }}
                    color="secondary"
                    component="span"
                    variant="outlined"
                  >
                    {selectedImage ||
                    (certificado.imageUrl && certificado.imageUrl !== "")
                      ? "cambiar imagen"
                      : "subir imagen"}
                  </Button>
                </label>
                {(selectedImage ||
                  (certificado.imageUrl && certificado.imageUrl !== "")) && (
                  <>
                    <Tooltip title={"Preview"}>
                      <Button
                        size="small"
                        onClick={() => setOpenPreviewDialog(1)}
                        style={{
                          ...buttonsStyle,
                          marginRight: "15px",
                        }}
                      >
                        <Visibility />
                      </Button>
                    </Tooltip>
                    <PreviewDialog
                      title={"Preview"}
                      open={openPreviewDialog === 1}
                      setOpen={setOpenPreviewDialog}
                      file={selectedImage}
                      src={
                        selectedImage
                          ? URL.createObjectURL(selectedImage)
                          : `${SERVER_URL}/${certificado.imageUrl}`
                      }
                    />
                    <Tooltip title={"Delete"}>
                      <Button
                        size="small"
                        onClick={() => {
                          setSelectedImage(null);
                          setCertificado({
                            ...certificado,
                            imageUrl: null,
                          });
                          if (imageInputRef.current) {
                            imageInputRef.current.value = "";
                          }
                        }}
                      >
                        <Delete />
                      </Button>
                    </Tooltip>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () => history.push("/certificados"),
            onSave: saveCertificado,
            onDelete: () => setOpenConfirmDialog(true),
            showDelete: !!certificadoId,
            setObj: setCertificado,
            obj: certificado,
          })}
          <CardHeader title="Editar certificado"></CardHeader>
          <CardBody>
            <MultiTabBlock
              tabs={[
                {
                  enable: true,
                  title: "Datos Generales",
                  renderContent: renderContentDatosGenerales,
                },
              ]}
            />

            {/* Checkboxes */}
            <div style={{ marginTop: "20px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={certificado.active || false}
                    onChange={() =>
                      setCertificado({ ...certificado, active: !certificado.active })
                    }
                    name="checkActive"
                  />
                }
                label="Active"
              />
            </div>
          </CardBody>
        </Card>

        {certificadoId && (
          <>
            <ConfirmDialog
              title={"Are you sure you want to delete this certificado?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteCertificado(certificadoId)
                  .then((res) => {
                    if (res.status === 204 || res.status === 200) {
                      alertSuccess({
                        title: "Deleted!",
                        customMessage: "Certificado deleted successfully",
                      });
                      history.push("/certificados");
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "Could not delete certificado.",
                    });
                  });
              }}
            />
          </>
        )}
      </>
    );
}
